(() => {
  const PLAYER_SELECTOR = '.zoria-product-videos__player';

  const enhancePlayer = (player) => {
    if (player.dataset.zoriaAccessibleControls === 'true') return;
    const video = player.querySelector('video');
    const playbackButton = player.querySelector('[data-zoria-video-playback]');
    const soundButton = player.querySelector('.internal-video__sound-btn');
    if (!video || !playbackButton) return;

    player.dataset.zoriaAccessibleControls = 'true';
    let userPaused = false;
    const syncPlayback = () => {
      const playing = !video.paused && !video.ended;
      player.classList.toggle('internal-video--playing', playing);
      playbackButton.setAttribute('aria-pressed', String(playing));
      playbackButton.setAttribute('aria-label', playing ? 'השהיית סרטון המוצר' : 'הפעלת סרטון המוצר');
    };
    const syncSound = () => {
      if (!soundButton) return;
      soundButton.setAttribute('aria-pressed', String(!video.muted));
      soundButton.setAttribute('aria-label', video.muted ? 'הפעלת שמע בסרטון המוצר' : 'השתקת שמע בסרטון המוצר');
    };

    playbackButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (video.paused || video.ended) {
        userPaused = false;
        const playPromise = video.play();
        if (playPromise) playPromise.catch(syncPlayback);
      } else {
        userPaused = true;
        video.pause();
      }
      syncPlayback();
    }, { capture: true });
    video.addEventListener('play', () => {
      if (userPaused) {
        video.pause();
        return;
      }
      syncPlayback();
    });
    ['playing', 'pause', 'ended'].forEach((eventName) => video.addEventListener(eventName, syncPlayback));
    video.addEventListener('volumechange', syncSound);
    syncPlayback();
    syncSound();
  };

  const init = (root = document) => root.querySelectorAll(PLAYER_SELECTOR).forEach(enhancePlayer);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
